export const COLUMNS = [
  {
    Header: "Tipo Conta",
    accessor: "contaGerencialTipo",
  },
  {
    Header: "Identificador",
    accessor: "identificadorW3ERP",
  },
  {
    Header: "Código C.G",
    accessor: "codigoContaGerencial",
  },
  {
    Header: "Informação",
    accessor: "informacao",
  },
  {
    Header: "Classificação",
    accessor: "classificacaoReceita",
  },
  {
    Header: "Produto Riber",
    accessor: "produto",
  },
  {
    Header: "Tipo Comissão",
    accessor: "tipoComissao",
  },
  {
    Header: "Status",
    accessor: "status",
    enableGlobalFilter: true,
  },
  {
    Header:"Código Kamino",
    accessor: "kamino",
  }
];

